import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-link-button"},[_c(VChip,{staticClass:"ma-auto",attrs:{"outlined":""},on:{"click":function($event){_vm.showShareLink = !_vm.showShareLink}}},[_c(VIcon,{attrs:{"left":"","small":""}},[_vm._v("fa-regular fa-share-nodes")]),_vm._v(" Share simulation ")],1),(_vm.showShareLink)?_c('ShareLink',{attrs:{"fundingChallengeTestId":_vm.fundingChallengeTestId},on:{"closeWindow":function($event){_vm.showShareLink = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }